import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../common/language.service';
import { LogoService } from '../../common/logo.service';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss']
})
export class ImpressumComponent implements OnInit {

  currentLang: string;

  constructor(
    private titleService: Title,
    private languageService: LanguageService, public logoService: LogoService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:@@impressum:Impressum`);
    this.currentLang = this.languageService.getLanguage();
  }

}
